"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PulseEffectManager = void 0;
const viewer_rendering_engine_animation_frame_engine_1 = require("@shapediver/viewer.rendering-engine.animation-frame-engine");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const THREE = __importStar(require("three"));
/** Applies and animates material pulse effects for rendered geometry objects. */
class PulseEffectManager {
    constructor(_renderingEngine) {
        this._renderingEngine = _renderingEngine;
        this._animationFrameEngine = viewer_rendering_engine_animation_frame_engine_1.AnimationFrameEngine.instance;
        this._pulsedObjects = new Map();
    }
    update(geometry, objects) {
        var _a, _b;
        const effect = (_a = geometry.effectPulses[geometry.effectPulses.length - 1]) === null || _a === void 0 ? void 0 : _a.effect;
        for (const object of objects) {
            this.clear(object);
            if (!effect || object instanceof THREE.InstancedMesh)
                continue;
            const source = object.material;
            if (Array.isArray(source) || !("color" in source))
                continue;
            const material = source.clone();
            object.material = material;
            const baseColor = material.color.clone();
            const effectColor = this._renderingEngine.createThreeJsColor((_b = effect.color) !== null && _b !== void 0 ? _b : "#00ff78");
            this._pulsedObjects.set(object, {
                baseColor,
                baseOpacity: material.transparent && "opacity" in material
                    ? material.opacity
                    : undefined,
                baseMaterial: source,
                blendColor: this.getBlendColor(baseColor, effectColor),
                colorDefinition: effect.color,
                effect,
                effectColor,
                material,
            });
        }
        this.updateAnimation();
    }
    clear(object) {
        const current = this._pulsedObjects.get(object);
        if (!current)
            return;
        if (object.material === current.material)
            object.material = current.baseMaterial;
        current.material.dispose();
        this._pulsedObjects.delete(object);
    }
    /** Restore an object's original material when it leaves the scene. */
    remove(object) {
        this.clear(object);
        this.updateAnimation();
    }
    dispose() {
        for (const object of this._pulsedObjects.keys())
            this.clear(object);
        this.updateAnimation();
    }
    updateAnimation() {
        if (this._pulsedObjects.size === 0) {
            if (this._animationFrameToken)
                this._animationFrameEngine.removeAnimationFrameCallback(this._animationFrameToken);
            if (this._continuousRenderingToken)
                this._renderingEngine.removeFlag(this._continuousRenderingToken);
            this._animationFrameToken = undefined;
            this._continuousRenderingToken = undefined;
            return;
        }
        if (!this._continuousRenderingToken)
            this._continuousRenderingToken = this._renderingEngine.addFlag(viewer_shared_types_1.FLAG_TYPE.CONTINUOUS_RENDERING);
        if (!this._animationFrameToken)
            this._animationFrameToken =
                this._animationFrameEngine.addAnimationFrameCallback((time) => this.animate(time));
    }
    animate(time) {
        var _a, _b, _c;
        for (const pulse of this._pulsedObjects.values()) {
            const phase = (time / 1000) * ((_a = pulse.effect.pulseSpeed) !== null && _a !== void 0 ? _a : 1.4) * Math.PI * 2;
            const intensity = ((_b = pulse.effect.intensity) !== null && _b !== void 0 ? _b : 0.3) * ((Math.sin(phase) + 1) / 2);
            if (pulse.colorDefinition !== pulse.effect.color) {
                pulse.effectColor = this._renderingEngine.createThreeJsColor((_c = pulse.effect.color) !== null && _c !== void 0 ? _c : "#00ff78");
                pulse.blendColor = this.getBlendColor(pulse.baseColor, pulse.effectColor);
                pulse.colorDefinition = pulse.effect.color;
            }
            pulse.material.color.lerpColors(pulse.baseColor, pulse.blendColor, THREE.MathUtils.clamp(intensity, 0, 1));
            if (pulse.baseOpacity !== undefined)
                pulse.material.opacity =
                    1 -
                        (1 - pulse.baseOpacity) *
                            Math.pow((1 - THREE.MathUtils.clamp(intensity, 0, 1)), 2);
        }
    }
    getBlendColor(baseColor, effectColor) {
        const redDelta = baseColor.r - effectColor.r;
        const greenDelta = baseColor.g - effectColor.g;
        const blueDelta = baseColor.b - effectColor.b;
        if (redDelta * redDelta +
            greenDelta * greenDelta +
            blueDelta * blueDelta >
            PulseEffectManager._colorSimilarityThreshold)
            return effectColor;
        const inverseColor = new THREE.Color(1 - baseColor.r, 1 - baseColor.g, 1 - baseColor.b);
        return baseColor.clone().lerp(inverseColor, 0.4);
    }
}
exports.PulseEffectManager = PulseEffectManager;
PulseEffectManager._colorSimilarityThreshold = 0.01;
//# sourceMappingURL=PulseEffectManager.js.map